/* eslint-disable @typescript-eslint/no-non-null-assertion */
import StoryblokPage from "../../../components/StoryblokPage";

export { getStaticPaths } from "../../../lib/routing/getStaticPaths";
export { getStaticProps } from "../../../lib/routing/getStaticProps";

export default StoryblokPage;
